import React, { useState, useEffect } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import DropdownSelectMapping from "~/components/Submissions/DropdownSelectMapping";
import FileIcon from "./FileIcon";
import TruncatedText from "./TruncatedText";

const FileAttachment = ({
  attached,
  highlightClassName,
  statusElement,
  fieldMappingGroups,
  selectedMapping,
  expandFileHeaders,
  onRemove,
  onSetMapping,
}) => {
  const [displayDetails, setDisplayDetails] = useState(false);

  useEffect(() => {
    setDisplayDetails(!!expandFileHeaders);
  }, [expandFileHeaders]);

  const renderFileHeaders = () => {
    const fileHeaders = attached.data?.length ? Object.keys(attached.data[0]) : null;
    if (!fileHeaders || !displayDetails) return null;

    const orderedFileHeaders = fileHeaders.sort((a, b) => a.localeCompare(b));

    return (
      <Droppable droppableId={`attachedFile#${attached.fileId}`}>
        {(provided) => (
          <div ref={provided.innerRef} className="attachments__info__container">
            {orderedFileHeaders.map((title, i) => (
              <Draggable
                key={attached.fileId + title}
                draggableId={`${attached.fileId}#${title}`}
                index={i}
              >
                {(provided) => (
                  <div
                    key={attached.fileId + title}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="tag tag--outline-bg-white tag--square tag--font-md tag--lowercase t--break"
                    data-testid={`draggable-${title}`}
                  >
                    {title}
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  };

  return (
    <div className={highlightClassName}>
      {statusElement}

      <div className="attachments__tile__row">
        <div className="attachments__tile__icon attachments__tile__icon--no-mgn">
          <FileIcon width={12} height={16} />
        </div>
        <TruncatedText
          text={attached.filename}
          className="attachments__tile__details__filename attachments__tile__details__filename--two-line"
          maxLines={2}
        />
      </div>
      <div className="attachments__tile__row" style={{ zIndex: 1 }}>
        <div className="flex flex-column flex-fill gap--4">
          <div className="t--sm t--500 t--upcase t--subtitle">Column Mapping</div>
          <DropdownSelectMapping
            mappings={fieldMappingGroups}
            attachment={attached}
            selectedMapping={selectedMapping}
            setSelectedMapping={(mapping) => onSetMapping(attached, mapping)}
          />
        </div>
      </div>
      <div className="flex justify-content-between">
        <div className="attachments__tile__action" onClick={(event) => onRemove(event)}>
          Remove
        </div>
        <div
          className="attachments__tile__action"
          onClick={(e) => {
            setDisplayDetails(!displayDetails);
          }}
        >
          {displayDetails ? "Hide Details" : "Show Details"}
        </div>
      </div>
      {renderFileHeaders()}
    </div>
  );
};

export default FileAttachment;
